import { useEffect } from "react"
import { useLocation } from "react-router"
import { applyDocumentMeta } from "@client/lib/document-meta"
import { DEFAULT_META, matchPageMeta } from "@shared/pages"

/**
 * Keeps the document head in sync with client-side navigation. Public pages
 * use their shared copy; everything else falls back to the default card so
 * private routes never keep a stale public title.
 */
export function MetaSync() {
  const { pathname } = useLocation()

  useEffect(() => {
    const match = matchPageMeta(pathname)
    if (match) {
      applyDocumentMeta(match.meta, { path: match.path })
      return
    }
    applyDocumentMeta(DEFAULT_META, { path: pathname.replace(/\/+$/, "") || "/" })
  }, [pathname])

  return null
}
